import React from 'react';
import { Unstable_Grid2 as Grid } from '@mui/material';

import { Select } from '@occc-app/design-system';
import { enrollmentStatusOptions } from '@occc-app/routes/Audience/components/FuelAndConvenienceProfile/constants';
import { Paths } from 'type-fest';
import { FuelAndConvenienceProfileValues } from './types';

export type HasACHTargetingAttributeProps = {
  formFieldName: string;
};

const subFieldName: Paths<FuelAndConvenienceProfileValues> = 'hasACH';

export const HasACHTargetingAttribute = ({ formFieldName }: HasACHTargetingAttributeProps) => {
  return (
    <Grid container spacing={3}>
      <Grid xs={12} sm={6} md={3}>
        <Select
          name={`${formFieldName}.${subFieldName}`}
          label='Enrollment Status'
          data={enrollmentStatusOptions}
          formControlProps={{ size: 'medium', margin: 'none' }}
        />
      </Grid>
    </Grid>
  );
};
